import { render, staticRenderFns } from "./SurveyRevisionHeader.vue?vue&type=template&id=01984f16&"
import script from "./SurveyRevisionHeader.vue?vue&type=script&lang=js&"
export * from "./SurveyRevisionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports